import { getDateByDateTimeValue } from '@elfsight/lib-utils';
import type { ScheduleDefaultsType } from '@elfsight/widget-conditional-display';
import { createGCEventURL } from './create-gc-event-url';
import { buildRRule } from './utils';

interface CreateGCEventURLFromScheduleProps {
  title: string;
  schedule: ScheduleDefaultsType;
  description?: string;
}

export const createGCEventURLFromSchedule = ({
  title,
  schedule,
  description
}: CreateGCEventURLFromScheduleProps) => {
  const { scheduleStart, scheduleEnd, scheduleIsAllDay, scheduleTimeZone } =
    schedule;

  const start = getDateByDateTimeValue(scheduleStart);
  const end = getDateByDateTimeValue(scheduleEnd);
  const recur = buildRRule(schedule, start);

  return createGCEventURL({
    text: title,
    details: description,
    dates: [start, end],
    allDay: scheduleIsAllDay,
    timeZone: scheduleTimeZone,
    recur
  });
};
